import { render, staticRenderFns } from "./foo.vue?vue&type=template&id=3571413c&scoped=true&"
import script from "./foo.vue?vue&type=script&lang=js&"
export * from "./foo.vue?vue&type=script&lang=js&"
import style0 from "./foo.vue?vue&type=style&index=0&id=3571413c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3571413c",
  null
  
)

export default component.exports